export default __webpack_public_path__ + "static/media/character_light.2598170a.svg";